<div class="rc-redesign-ft-on" #rcHeader>
  <div
    id="rc-title-bar"
    class="rc-title-bar"
    [ngClass]="{ 'rc-title-bar-box-shadow': !isStandaloneRC(), 'standalone-box-shadow': isStandaloneRC() }"
    f
  >
    <span class="title-container" [ngClass]="{ 'show-video-record-status': isRecording() }">
      <span class="rc-panel-title" #rcPanelTitle [ngClass]="{ 'hide-panel-title': hidePanelTitle() }">
        <span class="current-panel-title">{{ rcTabTitle }}</span>
        <span class="separator"></span>
      </span>
      <span id="device-title-container" class="device-title-container">
        <span #deviceIcon class="device-icon-container rc-title-icon" *ngIf="getDeviceFamily()">
          <span [ngClass]="getDeviceIconClass()"></span>
          <span [ngClass]="getDeviceScreenIconClass()"></span>
        </span>
        <span
          #deviceName
          class="link-container"
          [ngClass]="{ 'device-name-percentage': truncateDeviceName() }"
          *ngIf="hasDeviceURL()"
        >
          <a class="device-link" [href]="getDeviceURL()" target="_blank">
            <span class="device-title" placement="auto bottom">{{ getDeviceName() }}</span>
          </a>
        </span>
        <span
          class="link-container"
          [ngClass]="{ 'device-name-percentage': truncateDeviceName() }"
          *ngIf="!hasDeviceURL()"
        >
          <span class="device-title" placement="auto bottom">{{ getDeviceName() }}</span>
        </span>
        <span *ngIf="showActionMenu()">
          <div class="dropdown" (click)="$event.stopPropagation()" [matMenuTriggerFor]="rcTitlebarMenu">
            <button id="reporterMenu" type="button" class="btn btn-link btn-sm dropdown-toggle device-action-button">
              <span class="hd-icon hd-icon-more icon-md no-gutter device-action-button"></span>
            </button>
          </div>
        </span>
      </span>
      <div class="display-table-cell middle condensed line-sm video-recording-timer">
        <app-remote-control-video-recording-timer></app-remote-control-video-recording-timer>
      </div>
      <span class="spacer"></span>
    </span>

    <div class="display-table-cell middle condensed" class="line-sm" *ngIf="!canHideTicketSearchFill()"></div>
    <div class="buttons-container" #buttonsContainer1 *ngIf="showPopoutButtonsContainer()">
      <div class="popin-button-container" *ngIf="!rcHasError()">
        <a
          class="btn btn-link btn-sm rc-title-bar-buttons"
          [soti-tooltip]="getPopinToolTip()"
          placement="left"
          [attr.disabled]="getPopoutIsDisabled() ? '' : null"
          (click)="popin()"
        >
          <span class="hd-icon hd-icon-popin icon-md rc-title-bar-buttons-icon"></span>
        </a>
      </div>
    </div>
    <div class="buttons-container" #buttonsContainer2 *ngIf="showEmbeddedButtonsContainer()">
      <div class="minimized-button-container" *ngIf="!rcHasError()">
        <a class="btn btn-link btn-sm rc-title-bar-buttons" (click)="minimizeToggle()">
          <span *ngIf="!isMinimized()" class="hd-icon hd-icon-minimize icon-md rc-title-bar-buttons-icon"></span>
          <span *ngIf="isMinimized()" class="hd-icon hd-icon-maximize icon-md rc-title-bar-buttons-icon"></span>
        </a>
      </div>
      <div class="popout-button-container" *ngIf="!rcHasError() && showPopout">
        <a
          class="btn btn-link btn-sm rc-title-bar-buttons"
          *ngIf="!deviceState?.poppedOut"
          [soti-tooltip]="getPopoutToolTip()"
          placement="left"
          [attr.disabled]="getPopoutIsDisabled() || snapshotRefreshInProgress ? '' : null"
          (click)="popout()"
        >
          <span class="hd-icon hd-icon-popout icon-md rc-title-bar-buttons-icon"></span>
        </a>
      </div>

      <div class="stop-rc-button-container">
        <a class="btn btn-link btn-sm rc-title-bar-buttons" (click)="onRemoteControlCloseClick()">
          <span class="hd-icon hd-icon-close icon-md rc-title-bar-buttons-icon"></span>
        </a>
      </div>
    </div>
  </div>
</div>

<mat-menu #rcTitlebarMenu="matMenu" class="rc-titlebar-menu">
  <ng-template matMenuContent>
    <div
      *ngFor="let action of deviceActionList"
      (click)="executeAction(action.Content)"
      [ngClass]="{ 'grayed-out': isRecording() && action.Id == SoftReset_Id }"
      class="menu-item"
    >
      {{ action.Name }}
    </div>
  </ng-template>
</mat-menu>
